module.exports = __webpack_public_path__ + "media/images/audio-cv-icon-8d5361cc0d40c2889568c60f4afe7df2.png";